// 画图文件
import { getValue, textOverflow, sortPosition } from '../utils'

import {
  // btnColor,
  btnDisableColor,
  // btnDecryptColor,
  // lineColor,
  divideColor,
  // headerTextColor,
  // tableTextColor,
  // activeRowColor,
  cellPaddingWidth,
  stripeColor,
  // headerColor,
  headerHeight,
} from '../config'

import textFlexWidget from '../widget/text-flex'

import { canvasTableCellsCopyPlugin } from '../../../plugins/copy-cells/set-cell-style/canvas'


const GRAY_TOP = new Image()
GRAY_TOP.src = require('../images/graytop.png')

const GRAY_TOP_HOVER = new Image()
GRAY_TOP_HOVER.src = require('../images/graytophover.png')

const GRAY_BOTTOM = new Image()
GRAY_BOTTOM.src = require('../images/graybottom.png')

const GRAY_BOTTOM_HOVER = new Image()
GRAY_BOTTOM_HOVER.src = require('../images/graybottomhover.png')

const GRAY_TOP2 = new Image()
GRAY_TOP2.src = require('../../../assets/images/sort.png')

const GRAY_TOP2_HOVER = new Image()
GRAY_TOP2_HOVER.src = require('../../../assets/images/ascending-sort.png')

const GRAY_BOTTOM2 = new Image()
GRAY_BOTTOM2.src = require('../../../assets/images/sort.png')

const GRAY_BOTTOM2_HOVER = new Image()
GRAY_BOTTOM2_HOVER.src = require('../../../assets/images/descending-sort.png')

const CHECK_BORDER = new Image()
CHECK_BORDER.src = require('../images/checkborder.png')

const CHECK_HENG = new Image()
CHECK_HENG.src = require('../images/checkheng.png')

const CHECK_DISABLE = new Image()
CHECK_DISABLE.src = require('../images/checkdisable.png')

const CHECK_RIGHT_DISABLE = new Image()
CHECK_RIGHT_DISABLE.src = require('../images/checkrightdisable.png')

const CHECK_RIGHT = new Image()
CHECK_RIGHT.src = require('../images/checkright.png')

const IMG_ICON = new Image()
IMG_ICON.src = require('../images/imgicon.png')

const TIP_ICON = new Image()
TIP_ICON.src = require('../images/tipicon.png')

const EMPTY_TEXT = ''

export default {
  mounted () {
    this.isPaintImage = true
    this.sortCol = {
      num: 0,
      col: {},
      beforeCol: {}
    }
    this.checkboxIcon = {
      'true-true': CHECK_RIGHT_DISABLE,
      'true-false': CHECK_RIGHT,
      'false-true': CHECK_DISABLE,
      'false-false': CHECK_BORDER
    }
    this.repeatPainHeader = {}
    this._canvasTableCellsCopyInstance = canvasTableCellsCopyPlugin(this)
  },
  methods: {
    // 清除画布
    clearCanvas () {
      const { canvas, ctx, getLayerColumnOptions, layerCtx } = this
      // 清除2倍宽度，避免浏览器缩小，在放大造成重影等问题
      ctx.clearRect(-10, -10, canvas.width * 2, canvas.height * 2)
      if (getLayerColumnOptions.length > 0) {
        layerCtx.clearRect(-10, -10, canvas.width * 2, canvas.height * 2)
      }
    },
    // 从新绘画
    repaint () {
      this.initScroll()
      this.getDisplayRow()
      this.getDisplayCol()
      this.handleShowText()
      this.paint()
    },
    // 绘画
    paint (options = {}) {
      if (this.column.length > 0) {
        requestAnimationFrame(() => {
          this.draw(options)
        })
      }
    },
    // 绘画
    draw (options) {
      this.clearCanvas()
      if (this.flatData.length > 0) {
        this.paintActiveRow()
        this.paintLine()
        this.paintText()
        this.painHeader()
        this.paintFixedLeftColumn()
      } else {
        this.painHeader()
        // 2021-10-11 无数据时，固定列无需绘制
        // this.paintFixedLeftColumn()
        this.paintNoData()
      }
      // this.paintDivide(options.dividex) // 画分割竖线
      if (this.isPaintImage) {
        this.loadImage()
      }
    },
    // 绘画没有数据的
    paintNoData () {
      const { ctx, canvasBoxWidth, font, fontSize, ratio, headerHeight, options } = this
      ctx.font = font
      ctx.textBaseline = 'middle'
      ctx.fillStyle = this.config.tableTextColor
      let text = EMPTY_TEXT
      const emptyText = options.emptyText
      if (emptyText) {
        text = (typeof emptyText === 'function') ? emptyText() : emptyText
        text = text || EMPTY_TEXT
      }
      if (options.emptyTextRender && typeof options.emptyTextRender === 'function') { // 自定义绘制暂无数据
        options.emptyTextRender(this, ctx, {
          canvasBoxWidth,
          headerHeight,
          rowHeight: this.rowHeight,
          font,
          fontSize,
          ratio
        })
        return
      }
      if (text === EMPTY_TEXT) { // 2021-05-10 老的逻辑保留
        ctx.fillText(text, canvasBoxWidth / 2 - 2 * fontSize, ratio * (headerHeight + this.rowHeight / 2))
      } else { // 2021-05-10 根据文字长度计算居中位置
        ctx.fillText(text, canvasBoxWidth / 2 - (ctx.measureText(text).width / 2), ratio * (headerHeight + this.rowHeight / 2))
      }
    },
    // 画头部
    painHeader (cols, fixed = false, hWidth) {
      const { ctx, ratio, font, canvasConfig, scroll, checkedRow, allRowData,
        excludeSort, textCtx, options, headRenderOptions, sortCol, headerTipOptions } = this
      let headerH = this.headerHeight
      let midHeaderH = 0
      if (options.headerHeight) {
        midHeaderH = headerH - options.headerHeight
      } else {
        midHeaderH = headerH / 2
      }
      const disx = fixed ? 0 : scroll.disx
      cols = cols || this.displayCol
      // 2022-08-17 固定列可能为0
      // hWidth = hWidth || canvasConfig.aw
      hWidth = hWidth === 0 ? 0 : (hWidth || canvasConfig.aw)
      ctx.fillStyle = this.config.headerColor
      ctx.fillRect(-1, 0, hWidth, headerH)
      ctx.lineWidth = 1 * ratio
      ctx.strokeStyle = this.config.borderColor
      ctx.font = `bold ${font}`
      ctx.textBaseline = 'middle'
      this.repeatPainHeader = {}
      cols.forEach(item => {
        const x = item.x + item.width - disx
        let text = item.label
        // 二级表头，只画一次
        if (item._parentkey && item._parent && !this.repeatPainHeader[item._parentkey]) {
          let pw = 0
          let j = item._pindex
          const arr = item._parent.children.filter(item => item.show)
          for (; j < arr.length; j++) {
            let width = this.colWidthMap[arr[j].key] || arr[j].width
            pw += parseInt(width)
          }
          let w = (pw + item.x) - disx
          ctx.beginPath()
          ctx.moveTo(w, 0)
          ctx.lineTo(w, headerH)
          ctx.stroke()
          ctx.beginPath()
          ctx.moveTo(item.x - disx, midHeaderH)
          ctx.lineTo(w, midHeaderH)
          ctx.stroke()
          ctx.fillStyle = this.config.headerTextColor
          let label = textOverflow(textCtx, item._parent.label, item._parent.width, ratio).text
          let hx = (item._parent.x + (item._parent.width / 2) - (ctx.measureText(label).width / 2)) - disx
          let hy = 0
          if (options.headerHeight) {
            hy = (headerH - options.headerHeight) / 2
          } else {
            hy = headerH / 4
          }

          // 2022-07-27 一级头自定义渲染
          if (headRenderOptions[item._parentkey] && typeof headRenderOptions[item._parentkey] === 'function') {
            headRenderOptions[item._parentkey](ctx, {
              col: item._parent,
              label,
              x: hx,
              y: hy,
              disx,
              headerHeight: headerH,
              sortCol,
              canvasTable: this
            })
            this.repeatPainHeader[item._parentkey] = 1
          } else {
            ctx.fillText(label, hx, hy + 1) // 2021-4-6 文字偏上, 加一像素
            // 2021-08-02 增加一级头提示icon
            if (item._parent.headerTip || headerTipOptions[item._parentkey]) {
              this.painHeaderTip(item._parent, hx, hy)
            }
          }
          this.repeatPainHeader[item._parentkey] = 1
        }
        let sy = item._parentkey ? midHeaderH : 0
        ctx.beginPath()
        ctx.moveTo(x, sy)
        ctx.lineTo(x, headerH)
        ctx.stroke()
        // 横线
        ctx.fillStyle = this.config.headerTextColor
        let textx = item.x + (cellPaddingWidth * ratio) - disx
        if (!this.excludeSort[item.key]) {
          let textObj = textOverflow(textCtx, text, item.width, ratio)
          text = textObj.text
          if (item.textAlign === 'right' && !textObj.over) {
            let textLeft = item.width - textObj.tw - cellPaddingWidth
            // 剩余宽度
            let maxRightWidth = textLeft - cellPaddingWidth
            // 悬浮头
            if ((item.headerTip || headerTipOptions[item.key]) && maxRightWidth >= 14) {
              textLeft -= 14
              maxRightWidth -= 14
            }
            // 排序
            if (item.sortKeys && maxRightWidth >= 8) {
              textLeft -= 8
              maxRightWidth -= 8
            }
            // 缩进
            if (item.textFlexWidget && maxRightWidth >= 50) {
              textLeft -= 50
              maxRightWidth -= 50
            }
            textx = item.x + textLeft - disx
          }
          if (item.textAlign === 'center' && !textObj.over) {
            let textLeft = item.width - textObj.tw
            //  剩余宽度
            let maxRightWidth = textLeft - cellPaddingWidth * 2
            // 悬浮头
            if ((item.headerTip || headerTipOptions[item.key]) && maxRightWidth >= 14) {
              textLeft -= 14
              maxRightWidth -= 14
            }
            // 排序
            if (item.sortKeys && maxRightWidth >= 8) {
              textLeft -= 8
              maxRightWidth -= 8
            }
            // 缩进
            if (item.textFlexWidget && maxRightWidth >= 50) {
              textLeft -= 50
              maxRightWidth -= 50
            }
            textx = item.x + textLeft / 2 - disx
          }
        }
        let texty = 0
        if (options.headerHeight) {
          texty = item._parentkey ? headerHeight + options.headerHeight / 2 : headerH / 2
        } else {
          texty = item._parentkey ? (3 * headerH / 4) : midHeaderH
        }
        const paintParams = {
          x: item.x + (cellPaddingWidth * ratio) - disx,
          y: item._parentkey ? midHeaderH : 0,
          col: item,
          canvasTable: this,
          cellHeight: item._parentkey ? this.headerHeight - 30 : this.headerHeight,
          disx
        }
        this.runBeforeDraws(this.layerCtx, paintParams, 'painHeader')
        // 自定义画头部
        if (headRenderOptions[item.key] && typeof headRenderOptions[item.key] === 'function') {
          headRenderOptions[item.key](ctx, {
            col: item,
            text,
            x: textx,
            y: texty,
            disx,
            headerHeight: headerH,
            sortCol,
            canvasTable: this
          })
        } else {
          ctx.fillText(text, textx, texty + 1) // 2021-4-6 文字偏上, 加一像素
          if (item.key === excludeSort.$$selection) {
            let img = CHECK_BORDER
            if (checkedRow.length > 0 && checkedRow.length < allRowData.length) {
              img = CHECK_HENG
            } else if (checkedRow.length === allRowData.length && allRowData.length > 0) {
              img = CHECK_RIGHT
            }
            ctx.drawImage(img, textx + 6 * ratio, texty - 7 * ratio, 14 * ratio, 14 * ratio)
            return
          }

          // 2021-08-02 画提示icon
          if (item.headerTip || headerTipOptions[item.key]) {
            this.painHeaderTip(item, textx, texty)
          }

          if (item.key !== excludeSort.$$index && item.key !== excludeSort.$$operation && !item._showImage && !item._showCheckbox && !item._showUpload) {
            let buttonSort = !item._showButton || (item._showButton && (!item.button || item.buttonSortable))
            if (buttonSort && item.sortKeys && item.sortKeys.length === 2) {
              // 2021-08-02 判断是否有提示icon，适当增加间距
              let width = (item.headerTip || headerTipOptions[item.key]) ? sortPosition(textCtx, item.label) + 14 : sortPosition(textCtx, item.label)
              const diff = (2 * cellPaddingWidth + 8) * ratio
              sortCol.beforeCol = sortCol.col
              if (item.width > width + diff) {
                this.paintHeaderSort(item, textx, texty, width)
              }
            }
          }

          // 叠加画头部
          if (headRenderOptions[item.key] && typeof headRenderOptions[item.key] === 'object') {
            headRenderOptions[item.key].reRender(ctx, {
              col: item,
              text,
              x: textx,
              y: texty,
              disx,
              headerHeight: headerH,
              sortCol,
              canvasTable: this
            })
          }

          // 画文字伸缩部件
          if (item.textFlexWidget) {
            let render = textFlexWidget.render.bind(this)
            // 增加参数返回，disx(当前横向滚动条滚动的距离)，textCtx(文字绘制信息)
            render(ctx, {
              col: item,
              textCtx: this.textCtx,
              text,
              x: textx,
              y: texty,
              disx,
              headerHeight: headerH,
              sortCol,
              headerTipOptions // 判断头部是否增加提示文字
            })
          }
        }
      })
      ctx.beginPath()
      ctx.strokeStyle = this.config.headerBorderColor
      ctx.moveTo(0, headerH)
      ctx.lineTo(canvasConfig.aw, headerH)
      ctx.stroke()
    },
    // 头部排序
    paintHeaderSort (item, textx, texty, width) {
      const { ctx, ratio, sortCol } = this
      const isNewLayout = this.config.ieNewLayout
      let w = isNewLayout ? 12 * ratio : 8 * ratio
      let x = textx + width
      let y = isNewLayout ? texty - 6 * ratio : texty - 3 * ratio
      // 2021-11-23 排序表格头被动态隐藏后会导致 item._index 变更，导致排序icon错乱
      // if (sortCol.col._index === item._index && sortCol.num) {
      const sortArrow = isNewLayout ? GRAY_TOP2 : GRAY_TOP
      const sortArrowTop = isNewLayout ? GRAY_TOP2_HOVER : GRAY_TOP_HOVER
      const sortArrowBottom = isNewLayout ? GRAY_BOTTOM2_HOVER : GRAY_BOTTOM_HOVER
      if (sortCol.col.key === item.key && sortCol.num) {
        let img = sortCol.num === 1 ? sortArrowTop : sortArrowBottom
        ctx.drawImage(img, x, y, w, w)
      } else {
        ctx.drawImage(sortArrow, x, y, w, w)
      }
      sortCol.beforeCol = sortCol.col
    },
    // 画线
    paintLine (cols, width, fixed = false) {
      const { ctx, canvas, canvasConfig, scroll, displayRow, ratio } = this
      const disy = scroll.disy
      const disx = fixed ? 0 : scroll.disx
      cols = cols || this.displayCol
      // 2022-09-09 固定列可能为0
      // width || canvasConfig.aw
      width = width === 0 ? 0 : (width || canvasConfig.aw)
      // 画横线
      displayRow.forEach(item => {
        ctx.beginPath()
        ctx.lineWidth = 1 * ratio
        ctx.strokeStyle = this.config.borderColor
        ctx.moveTo(0 - disx, item.y - disy)
        ctx.lineTo(width - disx, item.y - disy)
        ctx.stroke()
      })
      // 画竖线
      cols.forEach(item => {
        let x = item.x + item.width - disx
        ctx.beginPath()
        ctx.lineWidth = 1 * ratio
        ctx.moveTo(x, 0)
        ctx.lineTo(x, canvas.height)
        ctx.stroke()
      })
    },
    // 填充表格文字 图标 图片处理
    paintText (cols, fixed = false) {
      const { ctx, ratio, font, scroll, displayRow,
        displayRowData, checkedRow, flatData, rowH,
        cachedImages, checkboxRows, page,
        uploadDisabledRows, excludeSort, drawColumnOptions,
        displayOverRowData, textAlignMap, layerColumnOptions, textCtx } = this
      const disy = scroll.disy
      const disx = fixed ? 0 : scroll.disx
      let x = 0
      let y = 0
      cols = cols || this.displayCol
      cols.forEach(col => {
        const key = col.key
        x = col.x - disx + (cellPaddingWidth * ratio)
        // 行
        displayRow.forEach((item, j) => {
          // 2021-4-6 文字偏上, 加一像素
          y = item.y - disy + (rowH / 2) + 1
          ctx.font = font
          ctx.textBaseline = 'middle'
          ctx.fillStyle = this.config.tableTextColor
          const rowIndex = flatData[item.index]._index - 1
          const paintParams = {
            x,
            y,
            disx,
            disy,
            col,
            row: this.data[rowIndex],
            drow: item,
            text: displayRowData[j] ? displayRowData[j][key] || '' : '',
            canvasTable: this,
            cellHeight: this.rowHeight
          }
          this.runBeforeDraws(this.layerCtx, paintParams, 'paintText')
          if (key === excludeSort.$$index) {
            // let t = flatData[item.index]._pageIndex // 排序之后的乱序的
            let t = (item.index + 1) + page.pageSize * (page.currentPage - 1)
            // 序号居中对齐、左对齐处理
            const { tw } = textOverflow(textCtx, String(t), 40, ratio)
            if (this.options.indexTextAlign && (this.options.indexTextAlign === 'right' || this.options.indexTextAlign === 'center')) {
              let textLeft = this.options.indexTextAlign === 'right' ? 40 - tw - cellPaddingWidth : (40 - tw) / 2
              ctx.fillText(t, x + textLeft - (cellPaddingWidth * ratio), y)
            } else {
              ctx.fillText(t, x, y)
            }
          } else if (key === excludeSort.$$selection) {
            const isFind = checkedRow.some(r => r._gtableuuid === flatData[item.index]._gtableuuid)
            let img = isFind ? CHECK_RIGHT : CHECK_BORDER
            img = flatData[item.index]._disabledCheck ? CHECK_DISABLE : img
            ctx.drawImage(img, x + 6 * ratio, y - 7 * ratio, 14 * ratio, 14 * ratio)
          } else if (key === excludeSort.$$operation) {
            this.paintOperationColumn(item)
          } else if (col._showButton) {
            this.paintButtonColumn(item, col, rowIndex, displayRowData[j], x, y)
          } else if (col._showCheckbox) {
            let opt = checkboxRows[rowIndex] ? checkboxRows[rowIndex][key] : { checked: false, disabled: false }
            const ck = this.checkboxIcon[`${opt.checked}-${opt.disabled}`]
            ctx.drawImage(ck, x + 6 * ratio, y - 7 * ratio, 14 * ratio, 14 * ratio)
          } else if (col._showImage) {
            let img = cachedImages[`${key}_${rowIndex}`] ? cachedImages[`${key}_${rowIndex}`] : IMG_ICON
            ctx.drawImage(img, x, y - rowH / 2, rowH, rowH)
          } else if (col._showUpload) {
            let bcolor = this.config.btnColor
            if (uploadDisabledRows[rowIndex].disabled) {
              bcolor = btnDisableColor
            }
            ctx.fillStyle = bcolor
            ctx.fillText('上传', x, y)
          } else if (drawColumnOptions[key] && typeof drawColumnOptions[key] === 'function') {
            drawColumnOptions[key]({
              ctx,
              x,
              y,
              disx,
              disy,
              col,
              row: this.data[rowIndex],
              displayRowData: displayRowData[j],
              drow: item,
              canvasTable: this,
              text: displayRowData[j] ? displayRowData[j][key] || '' : ''
            })
          } else {
            let text = displayRowData[j] ? displayRowData[j][key] || '' : ''
            let textAlignObj = textAlignMap.get(item.index)
            ctx.fillStyle = this.config.tableTextColor
            // 将System 画成 系统 2020-07-24
            text = text === 'System' ? '系统' : text
            // 文字右对齐
            if (textAlignObj && textAlignObj[key] && text && !(displayOverRowData[j] && displayOverRowData[j][key])) {
              ctx.fillText(text, x + textAlignObj[key] - (cellPaddingWidth * ratio), y)
            } else {
              ctx.fillText(text, x, y)
            }
          }
          // 分层配置
          if (layerColumnOptions[key] && typeof layerColumnOptions[key] === 'function') {
            layerColumnOptions[key](this.layerCtx, {
              x,
              y,
              disx,
              disy,
              col,
              row: this.data[rowIndex],
              drow: item,
              text: displayRowData[j] ? displayRowData[j][key] || '' : '',
              canvasTable: this
            })
          }
          try {
            this._canvasTableCellsCopyInstance && this._canvasTableCellsCopyInstance.paintCanvasCopyCellRect(this.layerCtx, paintParams)
          } catch (error) {
            window._apm && window._apm('captureException', new Error(`【ERP:_canvasTableCellsCopyInstance${error}`))
          }
        })
      })
    },
    // 画活动行
    paintActiveRow () {
      const { ctx, rowH, moveRowIndex, canvas, scroll, displayRow, stripe, ratio, headerHeight } = this
      const disy = scroll.disy - (headerHeight - this.rowHeight) * ratio
      const index = this.calculateActiveIndex()
      if (stripe) {
        displayRow.forEach(item => {
          ctx.beginPath()
          if (item.index !== 0 && item.index % 2 === 1) {
            ctx.fillStyle = stripeColor
          } else {
            ctx.fillStyle = '#fff'
          }
          ctx.fillRect(0, (item.index + 1) * rowH - disy, canvas.width, rowH)
          ctx.stroke()
        })
      }
      if (this.highlight && index !== null) {
        ctx.fillStyle = this.config.activeRowColor
        ctx.fillRect(0, (index + 1) * rowH - disy, canvas.width, rowH)
      }
      if (this.highlight && moveRowIndex !== null) {
        ctx.fillStyle = this.config.activeRowColor
        ctx.fillRect(0, (moveRowIndex + 1) * rowH - disy, canvas.width, rowH)
      }
      this.options.paintCanvasRow && this.options.paintCanvasRow(this)
    },
    // 画左边固定列
    paintFixedLeftColumn () {
      const { ctx, displayRow, rowH, moveRowIndex, scroll, fixedLeftCol, stripe } = this
      const disy = scroll.disy
      let index = this.calculateActiveIndex()
      let pWidth = this.getFixedLeftWidth()
      // 画头部
      // 填充颜色
      displayRow.forEach(obj => {
        let isActive = (index === obj.index) || (moveRowIndex === obj.index)
        let bgcolor = '#fff'
        if (this.highlight && isActive) {
          bgcolor = this.config.activeRowColor
        } else if (stripe) {
          if (obj.index !== 0 && obj.index % 2 === 1) {
            bgcolor = stripeColor
          }
        }
        fixedLeftCol.forEach(item => {
          ctx.fillStyle = bgcolor
          ctx.fillRect(item.x - 0.5, obj.y - disy, item.width, rowH)
        })
        this.options.paintCanvasFixed && this.options.paintCanvasFixed(this, obj)
      })
      this.paintLine(fixedLeftCol, pWidth, 'blue', true)
      this.paintText(fixedLeftCol, true)
      this.painHeader(fixedLeftCol, true, pWidth)
      // 滚动时候显示阴影
      // if (scroll.disx) {
      //   ctx.beginPath()
      //   ctx.fillStyle = lineColor
      //   ctx.shadowOffsetX = 0
      //   ctx.shadowOffsetY = 3
      //   ctx.shadowBlur = 5
      //   ctx.shadowColor = 'rgba(0, 0, 0, .4)'
      //   ctx.fillRect(pWidth, 0, 1, canvas.height)
      //   ctx.stroke()

      //   ctx.shadowOffsetX = 0
      //   ctx.shadowOffsetY = 0
      //   ctx.shadowBlur = 0
      //   ctx.shadowColor = 'rgba(0, 0, 0, 0)'
      // }
    },
    // 画操作列
    paintOperationColumn (item) {
      const { ctx, ratio, rowH, fontSize, scroll, allFixedRowData, flatData } = this
      const disy = scroll.disy
      let okey = this.excludeSort.$$operation
      let btnx = cellPaddingWidth * ratio + this.allColData.find(v => v.key === okey).x
      const rowIndex = flatData[item.index]._index - 1
      if (allFixedRowData[rowIndex] && allFixedRowData[rowIndex].length > 0) {
        let x = btnx
        for (let btnObj of allFixedRowData[rowIndex]) {
          if (!btnObj.show) {
            continue
          }
          // let label = typeof btnObj.label === 'function' ? btnObj.label(this.data[item.index]) : btnObj.label
          let label = btnObj.label
          ctx.fillStyle = btnObj.disabled ? btnDisableColor : this.config.btnColor
          // 2021-4-6 文字偏上, 加一像素
          let btny = item.y - disy + rowH / 2 + 1
          if (btnObj.render && typeof btnObj.render === 'function') {
            btnObj.render(ctx, label, x, btny, item, this)
          } else {
            ctx.fillText(label, x, btny)
          }
          let labelWidth = btnObj.renderWidth || label.length * fontSize
          x += labelWidth + 6 * ratio
        }
      }
    },
    paintButtonColumn (item, col, rowIndex, disRowData, x, y) {
      const { ctx, ratio, font, buttonDisabledRows, buttonOptions, data, textCtx, flatData } = this
      const key = col.key
      let bcolor = this.config.btnColor
      // button显示的兼容，TODO：后续需要优化
      let onePage = this.page.total <= this.page.pageSize
      let autoSort = this.options.sortType === 'auto'
      let rowData = (autoSort && onePage) ? data[rowIndex] : data[item.index]
      let btnOpt = buttonOptions[key]

      // 监控字段、虚拟号字段处理
      const markrow = flatData[item.index]

      // 同一个字段，不同单元格，可以存在不同的展示效果，如果是明文，则显示黑色
      const isMask = getValue(key + 'Mask', rowData) !== undefined
      const isVirtual = getValue(key + 'Virtual', rowData) !== undefined
      const isNormalText = (this.maskCol.hasOwnProperty(key) || this.virtualCol.hasOwnProperty(key)) && !isMask && !isVirtual
      // 敏感字段
      if (isNormalText || getValue(col.key + 'MaskSec', rowData) !== undefined) {
        bcolor = this.config.tableTextColor
      }
      if (buttonDisabledRows[rowIndex] && buttonDisabledRows[rowIndex][key]) {
        bcolor = btnDisableColor
      }
      if (col.color && btnOpt.color) {
        bcolor = typeof btnOpt.color === 'function' ? btnOpt.color(rowData) : btnOpt.color
      }
      ctx.fillStyle = bcolor
      if (col.icon) {
        const iconWidth = (btnOpt.size || 18) * ratio
        let icon = (btnOpt.icon && typeof btnOpt.icon === 'function') ? btnOpt.icon(rowData, rowIndex, { vm: this, markrow }) : btnOpt.icon
        if (icon && icon.includes('&#x')) {
          let iconfont = this.options.iconfont || 'iconfont'
          if (icon.includes(';') && !icon.endsWith(';')) { // icon + text
            let arr = icon.split(';')
            ctx.font = `${iconWidth}px ${iconfont}`
            ctx.fillStyle = col.color ? bcolor : 'red'
            ctx.fillText(String.fromCharCode(parseInt(arr[0].replace('&#x', ''), 16)), x, y)
            ctx.font = font
            ctx.fillStyle = this.config.tableTextColor
            icon = arr[1]
          } else { // only icon
            icon = String.fromCharCode(parseInt(icon.replace('&#x', ''), 16))
            ctx.font = `${iconWidth}px ${iconfont}`
            ctx.fillStyle = col.color ? bcolor : 'red'
            ctx.fillText(icon, x, y)
            icon = ''
          }
        }
        // text 部分
        if (icon) {
          if (btnOpt.textColor) {
            bcolor = typeof btnOpt.textColor === 'function' ? btnOpt.textColor(rowData) : btnOpt.textColor
            ctx.fillStyle = bcolor
          }
          let textObj = textOverflow(textCtx, icon, col.width - iconWidth, ratio)
          // 单元格居中对齐、右对齐
          let textAlignObj = this.textAlignMap.get(item.index)
          if (!textObj.over && textAlignObj && textAlignObj[col.key] && !(this.displayOverRowData[rowIndex] && this.displayOverRowData[rowIndex][col.key])) {
            ctx.fillText(textObj.text, x + textAlignObj[col.key] - (cellPaddingWidth * ratio), y)
          } else {
            ctx.fillText(textObj.text, x + iconWidth, y)
          }
          markrow[`_${col.key}FormatVal`] = icon
        }
      } else {
        let btxt = ''
        if (col.button) {
          btxt = typeof col.button === 'function' ? col.button(rowData) : col.button
          markrow[`_${col.key}FormatVal`] = btxt
        } else {
          btxt = disRowData ? disRowData[col.key] || '' : ''
        }
        const { text } = textOverflow(textCtx, btxt, col.width, ratio)
        // 单元格居中对齐、右对齐
        let textAlignObj = this.textAlignMap.get(item.index)
        if (textAlignObj && textAlignObj[col.key] && text && !(this.displayOverRowData[rowIndex] && this.displayOverRowData[rowIndex][col.key])) {
          ctx.fillText(text, x + textAlignObj[col.key] - (cellPaddingWidth * ratio), y)
        } else {
          ctx.fillText(text, x, y)
        }
      }
    },
    // 画分割线
    paintDivide (x) {
      if (x) {
        const { ctx, canvas, ratio } = this
        ctx.beginPath()
        ctx.lineWidth = 1 * ratio
        ctx.strokeStyle = divideColor
        ctx.moveTo(x, 0)
        ctx.lineTo(x, canvas.height)
        ctx.stroke()
      }
    },
    // 2021-08-02 画提示icon
    painHeaderTip (item, textx, texty) {
      const { ctx, textCtx, ratio } = this
      const diff = (2 * cellPaddingWidth + 8) * ratio
      let width = sortPosition(textCtx, item.label)
      if (item.width > width + diff) {
        let w = 12 * ratio
        let x = textx + width + 1
        let y = texty - 5
        ctx.drawImage(TIP_ICON, x, y, w, w)
      }
    },
    runBeforeDraws(ctx, params, type) {
      if (Array.isArray(this.beforeDraws) && this.beforeDraws.length) {
        this.beforeDraws.forEach(fn => {
          fn(ctx, params, type)
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/mixins/paint.js